// Vuetify Documentation https://vuetifyjs.com

import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import ripple from 'vuetify/lib/directives/ripple'
import getEnv from '@/util/env'

Vue.use(Vuetify, { directives: { ripple } })

const environment = getEnv('VUE_APP_ENVIRONMENT')

const theme = {
  primary: '#0078d4',
  secondary: '#9C27b0',
  accent: '#0078d4',
  info: '#00CAE3',
  success: '#4CAF50',
  warning: '#FB8C00',
  error: '#FF5252',
}

const devtheme = {
  primary: '#ff4466',
  secondary: '#1C22b0',
  accent: '#ff4466',
  info: '#00CAE3',
  success: '#4CAF50',
  warning: '#FB8C00',
  error: '#FF5252',
}

if (environment === 'dev') {
  var themetouse = devtheme
} else {
  themetouse = theme
}

export default new Vuetify({
  breakpoint: { mobileBreakpoint: 960 },
  icons: {
    values: { expand: 'mdi-menu-down' },
  },
  theme: {
    themes: {
      dark: themetouse,
      light: themetouse,
    },
    dark: false,
  },
})
